import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import { ShopProvider } from "./context/ShopContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import FloatingButtons from "./components/layout/FloatingButtons";
import "./pages/pages.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceSingle from "./pages/ServiceSingle";
import Taxis from "./pages/Taxis";
import TaxiSingle from "./pages/TaxiSingle";
import Team from "./pages/Team";
import TeamSingle from "./pages/TeamSingle";
import Gallery from "./pages/Gallery";
import Booking from "./pages/Booking";
import WorkProcess from "./pages/WorkProcess";
import CaseStudies from "./pages/CaseStudies";
import CaseSingle from "./pages/CaseSingle";
import Careers from "./pages/Careers";
import CareerSingle from "./pages/CareerSingle";
import CareerForm from "./pages/CareerForm";
import Faqs from "./pages/Faqs";
import Testimonials from "./pages/Testimonials";
import Partners from "./pages/Partners";
import BlogGrid from "./pages/BlogGrid";
import BlogList from "./pages/BlogList";
import BlogSingle from "./pages/BlogSingle";
import Contact from "./pages/Contact";

import ShopGrid from "./pages/shop/ShopGrid";
import ShopList from "./pages/shop/ShopList";
import ProductSingle from "./pages/shop/ProductSingle";
import Cart from "./pages/shop/Cart";
import Wishlist from "./pages/shop/Wishlist";
import Checkout from "./pages/shop/Checkout";
import OrderConfirmation from "./pages/shop/OrderConfirmation";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPwd from "./pages/auth/ForgotPwd";
import NotFound from "./pages/NotFound";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      className="scroll-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
    >
      <FaArrowUp />
    </button>
  );
}

export default function App() {
  return (
    <ShopProvider>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ServiceSingle />} />
          <Route path="/taxis" element={<Taxis />} />
          <Route path="/taxis/:id" element={<TaxiSingle />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/:id" element={<TeamSingle />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/work-process" element={<WorkProcess />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:id" element={<CaseSingle />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/:id" element={<CareerSingle />} />
          <Route path="/career-form" element={<CareerForm />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/blog-grid" element={<BlogGrid />} />
          <Route path="/blog-list" element={<BlogList />} />
          <Route path="/blogs/:id" element={<BlogSingle />} />
          <Route path="/contact-us" element={<Contact />} />

          <Route path="/shop-grid" element={<ShopGrid />} />
          <Route path="/shop-list" element={<ShopList />} />
          <Route path="/shop/:id" element={<ProductSingle />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />

          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-pwd" element={<ForgotPwd />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
      <FloatingButtons />
    </ShopProvider>
  );
}
